import React from 'react'
import Calculator from '../../components/Calculator'
import Footer from '../../components/Footer'
import Hero from '../../components/Hero'

export default function Home() {
  return (
    <>
      <Hero />
      <Calculator />
      <Footer />
    </>
  )
}
